// extracted by mini-css-extract-plugin
module.exports = {"linkList":"linkList-module--linkList--3CqOE","fontsLoading":"linkList-module--fonts-loading--3B4E7"};